<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="district.districtID > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="500px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="district"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-form-item label="区域编号">
          <el-input v-model="district.districtNO" disabled placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="区域名称" prop="districtName">
          <el-input v-model="district.districtName" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="上级区域">
          <el-select v-model="parentName" clearable placeholder="请选择">
            <el-option
                v-for="item in parentNameList"
                :key="item.districtID"
                :label="item.districtName"
                :value="item.districtName"
                @click.native="selectParentName(item.districtID)"/>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="district.note" placeholder="请输入"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

  export default {
    name:"DistrictEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        parentNameList: [],
        parentName: "",
        district: {
          districtID: "",
          districtNO: "",
          districtName: "",
          flevel: "",
          isDeleted: "",
          note: "",
          parentID: "",
        },
        ruleValidate: {
          districtName: {required: true, message: "区域名称不能为空",trigger: "blur"},
          // parentName: {required: true, message: "上级区域不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.district.districtID = id;
        this.dialogVisible = true;
        this.getParentNameList();
        if(id>0) {
          this.getData();
        }else {
          this.getNote();
        }
      },
      selectParentName(id) {
        console.log(id);
        this.district.parentID = id;
      },
      getParentNameList() {
        this.$http
          .get("basic", "districts/firstLevelList")
          .then(resp => {
            console.log(resp);
            this.parentNameList = resp;
          });
      },
      getParentName(id) {
        console.log(id);
        this.$http
          .get("basic", `districts/${id}`)
          .then(resp => {
            console.log(resp);
            if(resp) {
              this.parentName= resp.districtName ;
            }
          });
      },
      getData() {
        this.$http
          .get("basic", `districts/${this.district.districtID}`)
          .then(resp => {
            this.district = resp;
            this.getParentName(this.district.parentID);
            console.log(this.district);
          });
      },
      getNote() {
        this.$http
          .get("basic", "districts/selectNo")
          .then(resp => {
            this.district.districtNO = resp;
          });
      },
      handleSubmit() {
        if(this.district.districtID>0) {
          this.handleSubmitUpData();
        }else {
          this.handleSubmitSave();
        }
      },
      handleSubmitUpData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "districts", this.district)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "districts", this.district)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
